import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { createLeadData, getLeadStage } from "../../../store/actions"
import LeadStatusOption from 'components/dropdowns/Lead/LeadStatus'
import LeadTypeOption from 'components/dropdowns/Lead/LeadType'
import LeadStageOption from 'components/dropdowns/Lead/LeadStatge'
import LeadSourceOption from 'components/dropdowns/Lead/LeadSource'
import OtherDropdowns from "components/dropdowns/Other/OtherDropdowns"
import TitleDropdowns from "components/dropdowns/Other/titleDropdowns"
import SaveButton from "components/buttons/save"
import RsLink from "components/buttons/rsLink"
import {Row,Col,FormGroup,Label} from "reactstrap"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import moment from "moment-timezone";
import Select from "react-select"
import axios from "axios"
import { API_URL } from "helpers/app_url"
import PhoneInputField from "components/dropdowns/PhoneInputField"
import CurrencyInput from "react-currency-input-field"
import SafeField from "helpers/SafeField";
class CreateLead extends Component {
  constructor(props) {
    super(props)
    this.state = {
      optionGroup1:[]
    }
    this.handleSubmitLead = this.handleSubmitLead.bind(this);
  }
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };
  handleSubmitLead = (values, actions) => {
    //
    const payload = {
      firstName: values.firstName,
      lastName: values.lastName,
      leadStatusId: (values.leadStatusId) ? parseInt(values.leadStatusId) : 0,
      leadTypeId: (values.leadTypeId) ? parseInt(values.leadTypeId) : 0,
      leadSourceId: (values.leadSourceId) ? parseInt(values.leadSourceId) : 0,
      email: values.email,
      phone: values.phone,
      phoneExt: values.phoneExt,
      mobile: values.mobile,
      agentId: parseInt(localStorage.getItem("userId")),
      referedById:values.referedById,
      referedBy:values.referedBy,
      referralCode:values.referralCode,
      group: (values.group) ? parseInt(values.group) : 0,
      approxDealValue: (values.approxDealValue) ? parseInt(values.approxDealValue) : 0,
      notes: values.notes,
      submittedDate:moment(values.submittedDate).format('YYYY-MM-DD'),
      title:values.title,
      stageId: (values.stageId) ? parseInt(values.stageId) : 0,
      fullAddress:values.fullAddress,
      addressLine1:values.addressLine1,
      addressLine2:values.addressLine2,
      nearestIntersection:values.nearestIntersection,
      city:values.city,
      province:values.province,
      postal:values.postal,
      country:values.country,
      longitude:values.longitude,
      latitude:values.latitude
    }
    this.props.createLeadData(payload , (status) => {
       //
    if (status=== true) {
      
      this.props.toggleAddNew();
    }
    actions.setSubmitting(false);
  });
    //this.props.toggleAddNew();
  }
  componentDidMount() {
    this.fetchOptions();
  }
  fetchOptions = () => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    axios.get(`${API_URL}ContactExt/allforagent`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { agentId } 
      })
      .then((res) => {
        const filteredOptions = res.data.map((item) => ({
          value: `${item.firstName} ${item.lastName}`,
          label: `${item.firstName} ${item.lastName} - ${item.email}`,
        }));
  
        this.setState({ optionGroup1: filteredOptions, isLoading: false });
      })
      .catch((error) => {
        console.error("Error fetching referrals:", error);
        this.setState({ isLoading: false });
      });
  };
  
  render() {
    const { toggleAddNew, userdetail} = this.props;
    const { optionGroup1, isLoading } = this.state;
    return (
      <React.Fragment>
          
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          //title:'',
                          firstName: (this.state && this.state.firstName) || "",
                          lastName: (this.state && this.state.lastName) || "",
                          email: (this.state && this.state.email) || "",
                          phone: "",
                          mobile: "",
                          leadStatusId:"",
                          fullAddress:'',
                          addressLine1:'',
                          addressLine2:'',
                          nearestIntersection:'',
                          city:'',
                          province:'',
                          postal:'',
                          country:'',
                          longitude:0,
                          latitude:0,   
                          submittedDate: new Date(),
                        }}
                        validationSchema={Yup.object().shape({
                          //title: Yup.string().required('This field is required'),
                          firstName: Yup.string().required("This Field in required"),
                          lastName: Yup.string().required("This Field in required"),
                          email: Yup.string().email('Invalid email').required('This Field in required'),
                          mobile: Yup.string().required("This Field in required"),
                          //phone: Yup.string().matches(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/, 'Enter number is not valid'),
                        })}

                        onSubmit={this.handleSubmitLead}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Row>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="submittedDate">
                                    {this.props.t("Submitted Date")}
                                  </Label>
                                  <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.submittedDate && touched.submittedDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""
                                    value={values.submittedDate}
                                    onChange={(value) => setFieldValue('submittedDate', value[0])}
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d"
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                        
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="firstName">
                                    {this.props.t("First Name *")}
                                  </Label>
                                  <SafeField
                                    name="firstName"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.firstName && touched.firstName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="firstName"
                                  />
                                  <ErrorMessage
                                    name="firstName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>

                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="lastName">
                                    {this.props.t("Last Name *")}
                                  </Label>
                                  <SafeField
                                    name="lastName"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.lastName && touched.lastName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="lastName"
                                  />
                                  <ErrorMessage
                                    name="lastName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="fullAddress">
                                            {this.props.t("Location")}
                                          </Label>


                                          <PlacesAutocomplete
                                             value={values.fullAddress}
                                             onChange={(value) => setFieldValue('fullAddress', value)}
                                            onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                          >
                                       {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                  <div>
                                                    <input
                                                      {...getInputProps({
                                                        placeholder: 'Enter Address...',
                                                        className: 'form-control',
                                                      
                                                      })}
                                                    />
                                                    <div className="">
                                                      {loading ? <div>Loading...</div> : null}

                                                      {suggestions.map((suggestion, i) => {
                                                        const className = suggestion.active
                                                          ? 'suggestion-item--active'
                                                          : 'suggestion-item';
                                                        const style = suggestion.active
                                                          ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                          : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                                        return (
                                                          <div
                                                          key={i}
                                                            {...getSuggestionItemProps(suggestion, {
                                                              style,
                                                            })}
                                                          >
                                                            {suggestion.description}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                )}
                                              </PlacesAutocomplete>


                                        </FormGroup>
                                      </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="email">
                                    {this.props.t("Email *")}
                                  </Label>
                                  <SafeField
                                    name="email"
                                    type="text"
                                    
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.email && touched.email
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="email"
                                  />
                                  <ErrorMessage
                                    name="email"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                             
                              <Col md="4">
                               <PhoneInputField
                                label="Mobile"
                                name="mobile"
                                value={values.mobile}
                                setFieldValue={setFieldValue}
                                error={errors.mobile}
                                touched={touched.mobile}
                                country="ca"
                                required={true}
                              />
                               
                              </Col>
                              <Col md="4">
                               <PhoneInputField
                                label="Secondary Phone"
                                name="phone"
                                value={values.phone}
                                setFieldValue={setFieldValue}
                                error={errors.phone}
                                touched={touched.phone}
                                country="ca"
                                required={false}
                              />
                                
                              </Col>
                              {/* <Col md="2">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="phoneExt">
                                    {this.props.t("Ext")}
                                  </Label>
                                  <SafeField
                                    name="phoneExt"
                                    type="text"
                                    //value={values.phone}
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.phoneExt && touched.phoneExt
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="phoneExt"
                                  />
                                  <ErrorMessage
                                    name="phoneExt"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>  */}
                              <Col md="3">
                               <LeadTypeOption />
                              </Col>

                              <Col md="3">
                                    <LeadStatusOption />
                               
                              </Col>  
                              
                              <Col md="3">
                                    <LeadStageOption />
                              </Col> 
                              <Col md="3">
                              <OtherDropdowns
                                name="group"
                                label="Group"
                               fieldName="Lead:Group"
                              />
                              </Col>
                              <Col md="3">
                              <LeadSourceOption />
                              </Col>    
                              <Col md="3">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="approxDealValue">
                                    {this.props.t("Deal Value")}
                                  </Label>
                                   <CurrencyInput
                                    name="approxDealValue"
                                    value={values.approxDealValue}
                                    className="form-control"
                                    onValueChange={(value) => setFieldValue('approxDealValue', value)}
                                    prefix={userdetail.agentDefaultCurrencyCode}
                                    decimalsLimit={2}
                                  />
                                  {/* <SafeField
                                    name="approxDealValue"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.approxDealValue && touched.approxDealValue
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="approxDealValue"
                                  /> */}
                                </FormGroup>
                              </Col>
                             
                                 
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="referedBy">
                                    {this.props.t("Referred by")}
                                  </Label>
                                  <Select
                                    
                                    name="referedBy"
                                    isMulti={false}
                                    onChange={(selectedOption) => {
                                      setFieldValue("referedBy", selectedOption ? selectedOption.value : "");
                                    }}
                                    options={optionGroup1}
                                    classNamePrefix="select2-selection"
                                    isLoading={isLoading}
                                  />
                                 
                                </FormGroup>
                              </Col>
                              <Col md="2">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="referralCode">
                                    {this.props.t("Referral Code")}
                                  </Label>
                                  <SafeField
                                    name="referralCode"
                                    type="text"
                                    //value={values.referedBy}
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.referralCode && touched.referralCode
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="referralCode"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                    
                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="notes">
                                    {this.props.t("Notes ")}
                                  </Label>
                                  <SafeField
                                    name="notes"
                                    onChange={handleChange}
                                    as="textarea"

                                    className="form-control"

                                    id="notes"

                                  />
                                </FormGroup>
                              </Col>



                            </Row>






                            <div><SaveButton>{this.props.t("Save")}</SaveButton>{ " " } <RsLink onClick={toggleAddNew}>Close</RsLink></div>

                          </Form>
                        )}
                      </Formik>
                    
      </React.Fragment>
    )
  }
}

CreateLead.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  error: PropTypes.any,
  createLeadData: PropTypes.func,
  toggleAddNew:PropTypes.object,
  userdetail:PropTypes.object
}
const mapDispatchToProps = dispatch => ({
  createLeadData: (data, callback) => dispatch(createLeadData(data, callback)),
 })
export default connect('',mapDispatchToProps)(withTranslation()(CreateLead))
